import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Placeholder } from "react-bootstrap";
import { getMeasurmentSheetApi } from "../../../services/DocumentService";
import Circular from "./Circular/Circular";
import { connect } from "react-redux";

const MeasurementSheetDetailsLoading = () => {
  return (
    <div>
      <div className="card">
        <div className="card-body">
          <div className="w-100 px-2 mt-3">
            <Placeholder animation="glow">
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
            </Placeholder>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="d-flex align-item-center justify-content-between">
            <div className="w-100 px-2">
              <Placeholder animation="glow">
                <Placeholder
                  xs={12}
                  style={{ height: "20px" }}
                  className="rounded my-2"
                />
                <Placeholder
                  xs={12}
                  style={{ height: "20px" }}
                  className="rounded my-2"
                />
              </Placeholder>
            </div>

            <div className="w-100 px-2">
              <Placeholder animation="glow">
                <Placeholder
                  xs={12}
                  style={{ height: "20px" }}
                  className="rounded my-2"
                />
                <Placeholder
                  xs={12}
                  style={{ height: "20px" }}
                  className="rounded my-2"
                />
              </Placeholder>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

function MeasurementSheetDetails({ user }) {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();

  const fetchData = useCallback(async () => {
    setIsLoading(true);
    try {
      const resp = await getMeasurmentSheetApi(id);
      const resp_data = resp.data.results;
      setData(resp_data);
    } catch (error) {
      console.error("Error fetching user:", error);
      setData(null);
    } finally {
      setIsLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchData();
  }, [id, fetchData]);

  const renderBadge = (status) => {
    const statusClasses = {
      draft: "badge light border-0 badge-secondary badge-sm",
      pending: "badge light border-0 badge-warning badge-sm",
      issued: "badge light border-0 badge-primary badge-sm",
      reviewed: "badge light border-0 badge-info badge-sm",
      rejected: "badge light border-0 badge-danger badge-sm",
      default: "badge light border-0 badge-success badge-sm",
    };

    return (
      <span
        className={`badge ${statusClasses[status] || statusClasses.default}`}
      >
        {status}
      </span>
    );
  };

  return (
    <div className="container-fluid">
      {isLoading ? (
        <MeasurementSheetDetailsLoading />
      ) : data ? (
        <div className="row">
          <div className="col-md-4">
            <div className="card shadow-sm">
              <div className="card-header ">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center me-5">
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-sm btn-circle"
                      onClick={() => navigate("/te-sheet")}
                    >
                      <i className="fa-solid fa-arrow-left"></i>
                    </button>
                    <h5 className="mb-0 ms-2">TE-Sheet Details</h5>
                  </div>
                  {data.created_by?.id === user?.id && (
                    <button
                      className="btn btn-outline-primary btn-sm"
                      onClick={() => {
                        navigate(`/edit-sheet`, {
                          state: { data: data },
                        });
                      }}
                    >
                      Edit
                    </button>
                  )}
                </div>
              </div>
              <div className="card-body">
                <ul className="list-unstyled">
                  <li className="mb-3">
                    <strong>Title:</strong> {data?.title}
                  </li>
                  <li className="mb-3">
                    <strong>Document:</strong> {data?.document?.title}
                  </li>
                  <li className="mb-3">
                    <strong>Status:</strong> {renderBadge(data?.status)}
                  </li>
                  <ul className="list-unstyled">
                    {data.created_by && (
                      <li className="mb-3">
                        <strong>Created By:</strong> {data.created_by?.name}{" "}
                        <div className="text-muted">
                          Email: ({data.created_by?.email})
                        </div>
                        <small className="text-muted">
                          Created At: {data.created_by?.created_at}
                        </small>
                      </li>
                    )}
                    {data.reviewed_by && (
                      <li className="mb-3">
                        <strong>Reviewed By:</strong> {data.reviewed_by?.name}{" "}
                        <div className="text-muted">
                          Email: ({data.reviewed_by?.email})
                        </div>
                        <small className="text-muted">
                          Reviewed At: {data.reviewed_by?.reviewed_at}
                        </small>
                      </li>
                    )}
                    {data.approved_by && (
                      <li className="mb-3">
                        <strong>Approved By:</strong> {data.approved_by?.name}{" "}
                        <div className="text-muted">
                          Email: ({data.approved_by?.email})
                        </div>
                        <small className="text-muted">
                          Approved At: {data.approved_by?.approved_at}
                        </small>
                      </li>
                    )}
                    {data.issued_by && (
                      <li className="mb-3">
                        <strong>Issued By:</strong> {data.issued_by?.name}{" "}
                        <div className="text-muted">
                          Email: ({data.issued_by?.email})
                        </div>
                        <small className="text-muted">
                          Issued At: {data.issued_by?.issued_at}
                        </small>
                      </li>
                    )}
                  </ul>
                </ul>
                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting mb-3">
                  <table
                    id="empoloyees-tblwrapper"
                    className="table ItemsCheckboxSec dataTable no-footer mb-0"
                  >
                    <thead>
                      <tr>
                        <th>Parameter</th>
                        <th>Expected Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.parameters.map((item, index) => (
                        <tr key={index}>
                          <td>{item?.parameter_name} </td>
                          <td>{item?.expected_value} </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-8">
            <div className="card p-4 shadow-sm">
              <Circular SheetStatus={data?.status} />
            </div>
          </div>

        </div>
      ) : (
        <div className="card">
          <div className="card-body">
            <h4 className="text-center text-danger">
              ⚠️ Measurement Sheet Not Found! <br /> ID {id}
            </h4>
          </div>
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.auth?.user,
});
export default connect(mapStateToProps)(MeasurementSheetDetails);
